import gql from '@/services/gql';

const removeProductsById = gql(`
mutation remove_products_by_id(
  $ids: [uuid!]!
) {
  delete_asset(
    where: {
      _and: [
        { type: { _eq: "linesheet-product" } },
        { type_id: { _in: $ids }}
      ]
    }
  ) {
    affected_rows
    returning {
      id
      src
    }
  }

  delete_linesheet_product(
    where: {
      id: {
        _in: $ids
      }
    }
  ) {
    affected_rows
    returning {
      id
    }
  }
}`);

interface UpdateResponse {
  table: {
    affected_rows: number;
    returning: Array<{
      id: string;
      products: Array<{
        id: string;
        assets: Array<{
          id: string;
        }>;
      }>;
    }>;
  };
}

const update = gql<UpdateResponse>(`
mutation update_linesheet(
  $linesheet: linesheet_insert_input!
) {
  table: insert_linesheet(
    objects: [$linesheet]
    on_conflict: {
      constraint: linesheet_pkey
      update_columns: [
        archived
        contact
        currencies
        date
        date_created
        notes
        title
      ]
    }
  ) {
    affected_rows
    returning {
      id
      products {
        id
        assets {
          id
        }
      }
    }
  }
}`);

export {
  removeProductsById,
  update,
};
